import { render, staticRenderFns } from "./SetMarketsModal.vue?vue&type=template&id=ff6b7d38&scoped=true&"
import script from "./SetMarketsModal.vue?vue&type=script&lang=js&"
export * from "./SetMarketsModal.vue?vue&type=script&lang=js&"
import style0 from "./SetMarketsModal.vue?vue&type=style&index=0&id=ff6b7d38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6b7d38",
  null
  
)

export default component.exports